const FromArrOpenAccount = [
    {
      title: "备案开户状态：",
      inputtype: "select",
      inputflag: true,
      fontSize: 14,
      color: "#333333",
      lableheight: 20,
      X: false,
      types: "",
      placeholder: "请选择",
      width: 770,
      height: 32,
      disabled: false,
      marginLeft: 45,
      marginTop: 5,
      displayVal: "inline-block",
      fontWeightVal: 500,
      options: []
    },
  ];
  export default FromArrOpenAccount;
  